import Settings from "./settings";
import { BehaviorSubject } from 'rxjs';
import HTTP from "./http.service";

var Translation = {};

var loaded = false;

var loaded_obsrv = new BehaviorSubject(loaded);

Translation.keys = {};

Translation.activeLang = "en";

Translation.getAvailableLanguages = () => {
	return Object.keys(Translation.keys);
};

Translation.getCurrentLanguage = () => {
	return Translation.activeLang;
};

Translation.getTranslationsObsrv = () => {
	return loaded_obsrv;
};

Translation.loadBackupTranslations = lang => {
	if(Settings.debug) console.log('Using backup translations');
	let keys = require("../translations/" + lang.toLowerCase() + ".json");
	Translation.keys[lang] = keys;
	loaded_obsrv.next(true);
	loaded_obsrv.complete();
};

Translation.getTranslations = () => {
	let config = {
		method: "get",
		url: "/translations",
		params: {
			"container_id": Settings.translations_container
		}

	};
	let http = HTTP(config)
		.then(data => {
			if (data.data) {
				if(Settings.debug) console.log('Using api translations');
				Translation.keys = data.data;
				loaded_obsrv.next(true);
				loaded_obsrv.complete();
			} else {
				if(Settings.debug) console.log(data);
				Translation.loadBackupTranslations(Translation.activeLang);
			}
		})
		.catch(error => {
			if(Settings.debug) console.log(error);
			Translation.loadBackupTranslations(Translation.activeLang);
		});
	return http;
};

Translation.getTranslations();

Translation.loadSharedKeyStrings = (key) => {
	if (!key) return [];
	const strings = Translation["keys"][Translation.activeLang];
	return Object.keys(strings).filter(k=>k.includes(key));

}
export default Translation;